// extracted by mini-css-extract-plugin
export default {"info":"AddBankgiroAccount_info__SntEL","error":"AddBankgiroAccount_error__cIIEq","warning":"AddBankgiroAccount_warning__j5shT"};